import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/@core/auth/auth.service';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = async (
    route,
    state
) => {
    const router: Router = inject(Router);
    const authService: AuthService = inject(AuthService);

    // Check the authentication status
    const authenticated = await authService.check();

   // If the user is authenticated, redirect to home (or another page)
   if (authenticated) {
    return router.parseUrl('');
    }

    // Allow the user to access the page
    return true;
};
